<template>
  <modal>
    <div slot="footer"></div>
    <div slot="body">
      <v-progress-circular
        color="primary"
        indeterminate
      ></v-progress-circular>
      Saving... This might take a few minutes
    </div>
    <div slot="footer"></div>
  </modal>
</template>

<script>
import modal from "@/components/modal";
export default {
  components: { modal }

}
</script>

<style>

</style>
